module.exports = __webpack_public_path__ + "img/line.05bf1c84.jpg";